import { checkFeatureAuth } from '@/services'
import { gtrSendEvents } from '@/micro-app'
// 权限缓存
const authCache = {}
// 处理并发请求
const resolveCallbacks = {}
async function getAuthCache(nodeKey) {
  return new Promise(resolve => {
    if (resolveCallbacks[nodeKey]) {
      resolveCallbacks[nodeKey].push(resolve)
    } else {
      resolveCallbacks[nodeKey] = [resolve]
      checkFeatureAuth({ nodeKey })
        .then(res => {
          authCache[nodeKey] = res
          resolveCallbacks[nodeKey].forEach(i => {
            i(res)
          })
          delete resolveCallbacks[nodeKey]
        })
        .catch(e => {
          console.warn(e)
          resolveCallbacks[nodeKey].forEach(i => {
            i(false)
          })
          delete resolveCallbacks[nodeKey]
        })
    }
  })
}
/**
 * 获取权限
 * @param {String} nodeKey - 节点key
 * @returns {Promise<Boolean>} - 权限
 */
export async function gtrAuth(nodeKey) {
  if (authCache[nodeKey]) {
    return authCache[nodeKey]
  }
  try {
    return await getAuthCache(nodeKey)
  } catch (e) {
    console.warn(e)
    return undefined
  }
}
/**
 * 获取多个权限
 * @param {Array<String>} authKeys - 节点key数组
 * @returns {Promise<Array<Boolean>>} - 权限数组
 */
export async function gtrAuths(authKeys) {
  if (!Array.isArray(authKeys)) return console.warn(`${authKeys}不是一个数组`)
  return Promise.all(
    authKeys.map(async key => {
      return gtrAuth(key)
    }),
  )
}
// 权限弹窗控制
export function gtrAuthNotify(data) {
  gtrSendEvents.GTR_LISTEN_EVENT_PERMISSION_NOTIFY(data)
}
